module.exports = __webpack_public_path__ + "8e6f0dc9fe24bbf35f63c910414f3a14.svg";